<template>
  <section>
    <SubBtnBox
      :cancelTextName="progressPamars.step <= 1 ? '取消' : '上一步'"
      :comfirmTextName="progressPamars.step >= maxStep ? '提交' : '下一步'"
      :customSubmit="true"
      :customCancel="true"
      @cancel="toPreStep"
      @customSub="nextStep"
    />
  </section>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
export default {
  components: {
    SubBtnBox,
  },
  model: {
    prop: 'progressPamars',
    event: 'cc',
  },
  props: {
    progressPamars: {
      type: Object,
      default: () => ({
        step: 1,
      }),
    },
    checkNextStep: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      maxStep: 2,
    };
  },
  methods: {
    toPreStep () {
      if (this.progressPamars.step <= 1) {
        this.close();
      } else {
        this.progressPamars.step--;
        if (this.progressPamars.step < 0) {
          this.progressPamars.step = 1;
        }
      }
      this.$emit('preStep', this.progressPamars.step);
    },
    toNextStep () {
      if (this.progressPamars.step < this.maxStep) {
        this.progressPamars.step++;
      }
    },
    nextStep () {
      if (this.checkNextStep) {
        // 手动控制下一步
        this.$emit('nextStep', this.progressPamars.step);
      } else {
        // 下一步不检测，到最后一步才抛出函数调用
        this.toNextStep();
        if (this.progressPamars.step >= this.maxStep) {
          this.$emit('nextStep', this.progressPamars.step);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
